"use client";

import { usePathname } from "next/navigation";
import { ViewItemListProductAnalytics } from "@/components/analytics/view-item-list-product-analytics";
import { ErrorMessage } from "@/components/error-message";
import { getErrorMessage } from "@/utils/error-messages";

export default function NotFound() {
  const pathname = usePathname();
  const isSearchPage = pathname && /\/search\/?$/.test(pathname);

  const { title, message } = getErrorMessage("404");

  return (
    <>
      <ErrorMessage title={title} message={message} />
      {isSearchPage && (
        <ViewItemListProductAnalytics
          item_list_name="search"
          item_list_state="failed_search"
        />
      )}
    </>
  );
}
